import { formatNumberMix } from '@/utils'
export default {
  data() {},
  methods: {
    setCountList(data) {
      let list = new Array(4).fill(null)
      list[0] = {
        title: this.$t('performance-board::data::visitor_title'),
        count: data && this.$dataCheck(formatNumberMix(data.clientCnt, 0, ',')),
        down: data && data.clientCntRatio ? data.clientCntRatio < 0 : false,
        statisticsDays: data && this.$dataCheck(data.statisticsDays),
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastClientCnt, 2, ',')),
        rate: data && this.$dataCheck(formatNumberMix(data.clientCntRatio, 2)),
        tooltip: this.$t('performance-board::data::visitor_tooltip')
        // disable: true
      }
      list[1] = {
        title: this.$t('performance-board::data::changeRate_title'),
        count: data && this.$dataCheck(formatNumberMix(data.transRate, 2, ',')),
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastTransRate, 2, ',', '%')),
        statisticsDays: data && this.$dataCheck(data.statisticsDays),
        down: data && data.transRateRatio ? data.transRateRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.transRateRatio, 2)),
        suffix: '%',
        tooltip: this.$t('performance-board::data::changeRate_tooltip')
      }
      list[2] = {
        title: this.$t('performance-board::data::visitorTime_title'),
        count: data && this.$dataCheck(formatNumberMix(data.viewTimePer, 2, ',')),
        down: data && data.viewTimePerRatio ? data.viewTimePerRatio < 0 : false,
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastViewTimePer, 2, ',')),
        statisticsDays: data && this.$dataCheck(data.statisticsDays),
        rate: data && this.$dataCheck(formatNumberMix(data.viewTimePerRatio, 2)),
        tooltip: this.$t('performance-board::data::visitorTime_tooltip')
      }
      list[3] = {
        title: this.$t('performance-board::data::outRate_title'),
        count: data && this.$dataCheck(formatNumberMix(data.outRate, 2, ',')),
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastOutRate, 2, ',', '%')),
        down: data && data.outRateRatio ? data.outRateRatio < 0 : false,
        statisticsDays: data && this.$dataCheck(data.statisticsDays),
        rate: data && this.$dataCheck(formatNumberMix(data.outRateRatio, 2)),
        suffix: '%',
        tooltip: this.$t('performance-board::data::outRate_tooltip')
      }
      return list
    },
    setChangeFunnelConfig(data = [], param) {
      return {
        type: 'funnel',
        title: this.$t('performance-board::data::funnel_title'),
        ref: 'funnelChartVistor',
        height: '305px',
        filterParam: true,
        filterTitle: '转化率分母：',
        filterOptions: [
          { label: this.$t('performance-board::data::funnel_pageUV'), value: '1' },
          { label: this.$t('performance-board::data::funnel_stationUV'), value: '2' }
        ],
        filter: param ? param : '',
        columns: [
          {
            id: 'action',
            label: ''
          },
          {
            id: 'clientCnt',
            label: this.$t('performance-board::data::funnel_clientCnt')
          },
          {
            id: 'transRate',
            label: this.$t('performance-board::data::funnel_transRate')
          },
          {
            id: 'transRateRatio',
            label: this.$t('performance-board::data::funnel_transRateRatio')
          }
        ],
        tableData: data
      }
    },
    // setUtmSourceChartsConfig(data = [], param) {
    //     return {
    //         type: 'ring',
    //         title: this.$t('performance-board::data::utmSource_title'),
    //         ref: 'areaSoureRingCharts',
    //         height: '325px',
    //         filterParam: true,
    //         filterTitle: this.$t('performance-board::data::utm_sign') + '：',
    //         filterOptions: [
    //             { label: 'utmSource', value: 'utm_source' },
    //             { label: 'utmCampaign', value: 'utm_campaign' },
    //             { label: 'utmMedium', value: 'utm_medium' },
    //             { label: 'utmTerm', value: 'utm_term' },
    //             { label: 'utmContent', value: 'utm_content' },
    //         ],
    //         filter: param ? param : '',
    //         tip: '',
    //         chart: {
    //             tooltip: {
    //                 trigger: 'item',
    //                 formatter: (params, ticket, callback) => {
    //                     return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color}"></span><span>${params.name}  </span><span style="font-weight:900;">${params.value}%</span>`
    //                 }
    //             },
    //             series: [
    //                 {
    //                     type: 'pie',
    //                     radius: ['50%', '70%'],
    //                     label: {
    //                         show: false
    //                     },
    //                     itemStyle: {
    //                         normal: {
    //                             labelLine: {
    //                                 show: false
    //                             }
    //                         }
    //                     },
    //                     emphasis: {
    //                         label: {
    //                             show: false,
    //                             fontSize: '12'
    //                         }
    //                     },
    //                     labelLine: {
    //                         show: false
    //                     },
    //                     data: [
    //                         ...data.map(item => {
    //                             return {
    //                                 value: item.utmPer,
    //                                 rate: item.utmPer,
    //                                 name: item.utm
    //                             }
    //                         })
    //                     ]
    //                 }
    //             ]
    //         }
    //     }
    // },
    setUtmSourceTable(data = [], param) {
      return {
        title: this.$t('performance-board::data::utmSource_title'),
        ref: 'utmSourceTable',
        height: '305px',
        cancelShadow: true,
        tableData: data,
        filter: param ? param : '',
        filterParam: true,
        filterTitle: this.$t('performance-board::data::utm_sign') + '：',
        filterOptions: [
          { label: 'utmSource', value: 'utm_source' },
          { label: 'utmCampaign', value: 'utm_campaign' },
          { label: 'utmMedium', value: 'utm_medium' },
          { label: 'utmTerm', value: 'utm_term' },
          { label: 'utmContent', value: 'utm_content' }
        ]
      }
    },
    // setAreaSoureCharts(data = []) {
    //     return {
    //         type: 'ring',
    //         title: this.$t('performance-board::data::areaSoure_title'),
    //         ref: 'areaSoureRingCharts',
    //         height: '325px',
    //         tip: '',
    //         chart: {
    //             tooltip: {
    //                 trigger: 'item',
    //                 formatter: (params, ticket, callback) => {
    //                     return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color}"></span><span>${params.name}  </span><span style="font-weight:900;">${params.value}</span><br/>
    //                           <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;"></span><span>${params.name}  </span><span style="font-weight:900;">${params.data.rate}%</span>`
    //                 }
    //             },
    //             series: [
    //                 {
    //                     type: 'pie',
    //                     radius: ['50%', '70%'],
    //                     label: {
    //                         show: false,
    //                         position: 'left'
    //                     },
    //                     itemStyle: {
    //                         normal: {
    //                             labelLine: {
    //                                 show: false
    //                             }
    //                         }
    //                     },
    //                     emphasis: {
    //                         label: {
    //                             show: false,
    //                             fontSize: '12'
    //                         }
    //                     },
    //                     labelLine: {
    //                         show: false
    //                     },
    //                     data: [
    //                         ...data.map(item => {
    //                             return {
    //                                 value: item.clientCnt,
    //                                 rate: item.clientCntPer,
    //                                 name: item.clientArea
    //                             }
    //                         })
    //                     ]
    //                 }
    //             ]
    //         }
    //     }
    // },
    setAreaSoureTable(data = []) {
      return {
        title: this.$t('performance-board::data::areaSoure_title'),
        ref: 'areaSoureTable',
        height: '325px',
        cancelShadow: true,
        tableData: data
      }
    },
    setVisitorPageConfig(data = []) {
      return {
        title: this.$t('performance-board::data::pageVisitor_title'),
        ref: 'visitorPageTable',
        height: '325px',
        cancelShadow: true,
        tableData: data
      }
    },
    setSearchTableConfig(data = []) {
      return {
        title: '',
        ref: 'searchTable',
        height: '525px',
        cancelShadow: true,
        tableData: data
      }
    },
    setAddBuyTableConfig(data = []) {
      return {
        title: '',
        ref: 'addBuyTable',
        height: '525px',
        cancelShadow: true,
        tableData: data
      }
    },
    setIntegrationDevice(data = []) {
      return {
        title: this.$t('performance-board::data::deviceTable'),
        ref: 'deviceTable',
        height: '325px',
        cancelShadow: true,
        tableData: data
      }
    },
    setClientCountry(data = []) {
      return {
        type: 'lineAndBar',
        title: this.$t('performance-board::data::clientCountryCharts'),
        ref: 'clientCountryCharts',
        height: '325px',
        tip: '',
        chart: {
          tooltip: {
            formatter: (params, ticket, callback) => {
              let str = `<span style="font-weight:900;">${params[0].name} </span><br/>`
              params.forEach((item, index) => {
                if (item.seriesType !== 'line') {
                  str += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color}"></span><span>${item.seriesName}  </span><span style="font-weight:900;">${item.value} </span><br/>`
                } else {
                  str += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color}"></span><span>${item.seriesName}  </span><span style="font-weight:900;">${item.value}%</span><br/>`
                }
              })
              return str
            }
          },
          legend: {
            data: [this.$t('performance-board::data::访客数量'), this.$t('performance-board::data::转化率')]
          },
          xAxis: {
            data: data.map(item => item.country)
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#DCDFE6',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#9DA1C3'
              }
            },
            {
              type: 'value',
              min: 0,
              splitLine: {
                show: false
              },
              axisLabel: {
                margin: 16,
                color: '#9DA1C3',
                formatter: '{value} %'
              }
            }
          ],
          series: [
            {
              name: this.$t('performance-board::data::访客数量'),
              type: 'bar',
              data: data.map(item => Number(item.clientCnt))
            },
            {
              name: this.$t('performance-board::data::转化率'),
              type: 'line',
              yAxisIndex: 1,
              tooltip: {
                formatter: '{b}: {c}%'
              },
              data: data.map(item => Number(item.clientCntRatio))
            }
          ]
        }
      }
    },
    setUtmCountry(data = []) {
      return {
        type: 'lineAndBar',
        title: this.$t('performance-board::data::utmTransCharts'),
        tooltip: this.$t('performance-board::data::utmTransChartsTIps'),
        ref: 'utmTransCharts',
        height: '325px',
        tip: '',
        chart: {
          tooltip: {
            formatter: (params, ticket, callback) => {
              let str = `<span style="font-weight:900;">${params[0].name} </span><br/>`
              params.forEach((item, index) => {
                if (item.seriesType !== 'line') {
                  str += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color}"></span><span>${item.seriesName}  </span><span style="font-weight:900;">${item.value} </span><br/>`
                } else {
                  str += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color}"></span><span>${item.seriesName}  </span><span style="font-weight:900;">${item.value}%</span><br/>`
                }
              })
              return str
            }
          },
          legend: {
            data: [this.$t('performance-board::data::用户数'), this.$t('performance-board::data::转化率')]
          },
          xAxis: {
            data: data.map(item => item.utmSource)
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#DCDFE6',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#9DA1C3'
              }
            },
            {
              type: 'value',
              min: 0,
              splitLine: {
                show: false
              },
              axisLabel: {
                margin: 16,
                color: '#9DA1C3',
                formatter: '{value} %'
              }
            }
          ],
          series: [
            {
              name: this.$t('performance-board::data::用户数'),
              type: 'bar',
              data: data.map(item => Number(item.allUserNum))
            },
            {
              name: this.$t('performance-board::data::转化率'),
              type: 'line',
              yAxisIndex: 1,
              tooltip: {
                formatter: '{b}: {c}%'
              },
              data: data.map(item => Number(item.transRate))
            }
          ]
        }
      }
    }
  }
}
